import { MantineThemeOverride } from '@mantine/core';

export type PortalTheme = NonNullable<MantineThemeOverride['components']>['Portal'];

export const Portal: PortalTheme = {
  // todo: define
};
